module.exports = __webpack_public_path__ + "img/facebook.79f33c26.svg";